import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';

import Meta from 'shared/containers/MetaContainer';
import Grid from 'brastrap/containers/grid/GridContainer';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import SizeQuiz from 'brastrap/containers/size-quiz/SizeQuizContainer';

import { getWrapperContainers } from '../../../actions/editorial';

export const SETTING_GROUP = 'size-quiz';

const messages = defineMessages({
  title: {
    id: 'size-quiz-page.title',
    defaultMessage: 'Bra Fit Finder',
  },
});

const SizeQuizPage = (props: Props) => {
  const {
    intl: { formatMessage },
    getContainers,
    headerContainers,
    footerContainers,
  } = props;

  useEffect(() => {
    getContainers();
  }, []);

  return (
    <Meta title={formatMessage(messages.title)}>
      <div className="c-page__main--small">
        <Grid>
          <Grid.Content>
            {headerContainers && !!headerContainers.length && (
              <EditorialContainer containers={headerContainers} />
            )}
            <SizeQuiz />
            {footerContainers && !!footerContainers.length && (
              <EditorialContainer containers={footerContainers} />
            )}
          </Grid.Content>
        </Grid>
      </div>
    </Meta>
  );
};

SizeQuizPage.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
  getContainers: PropTypes.func.isRequired,
  headerContainers: PropTypes.array,
  footerContainers: PropTypes.array,
};

const mapStateToProps = state => ({
  headerContainers: state.content.headerContainers || [],
  footerContainers: state.content.footerContainers || [],
});

const mapDispatchToProps = dispatch => ({
  getContainers: () => dispatch(getWrapperContainers(SETTING_GROUP)),
});

SizeQuizPage.populateStore = async store => {
  store.dispatch(getWrapperContainers(SETTING_GROUP));
};

const WrappedSizeQuizPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SizeQuizPage));

export default WrappedSizeQuizPage;
